import { Dispatch, ThunkAction } from '../../../types/actions';
import { IGetState, TBoardId } from '../../../types/types';
import { boardSetUserMeta } from './boardSetUserMeta';

export const boardSetColorTagsSearchScrolled = (
    boardId: TBoardId,
    isColorTagsSearchScrolled: boolean,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(boardSetUserMeta(boardId, { isColorTagsSearchScrolled }));
    };
    return action;
};
